module.exports = __webpack_public_path__ + "img/garlic.5437a3dc.svg";